import {Pipe, PipeTransform} from '@angular/core';
import {RuleType} from "@afidium/ts-facade/model/ruleType";
import {Yii} from "../../../../../interfaces/Yii";
import {PenaltyType} from "@afidium/ts-facade/model/penaltyType";
import {PriceRealAmountPipe} from "../../../../../pipes/price/priceRealAmount.pipe";
import {EPenaltyType} from "../booking-price-card.enum";
import {SafeHtml} from "@angular/platform-browser";
import type {XRoleForRuleType} from '@afidium/ts-facade/model/xRoleForRuleType';
import {LuggageUnitPipe} from "./luggage-unit.pipe";
import {FareComponentInBookingType} from "@afidium/ts-facade/model/fareComponentInBookingType";

export interface IKeyValue {
    key: string;
    value: string | SafeHtml;
}


class Wording {
    public noPrice: string = Yii.t('wui-shared-js', 'Aucune information de tarification à afficher');
    public totalPrice: string = Yii.t('wui-shared-js', 'Total');
    public basePrice: string = Yii.t('wui-shared-js', 'Base');
    public taxPrice: string = Yii.t('wui-shared-js', 'Taxe');
    public segment: string = Yii.t('wui-shared-js', 'Segment');
    public infant: string = Yii.t('wui-shared-js', 'Bébé');
    public child: string = Yii.t('wui-shared-js', 'Enfant');
    public luggage: string = Yii.t('wui-shared-js', 'Bagage');
    public cancellationBeforeDeparture: string = Yii.t('wui-shared-js', 'Ann av dép');
    public cancellationAfterDeparture: string = Yii.t('wui-shared-js', 'Ann ap dép');
    public exchangeBeforeDeparture: string = Yii.t('wui-shared-js', 'Ech av dép');
    public exchangeAfterDeparture: string = Yii.t('wui-shared-js', 'Ech ap dép');
    public fareBasis: string = Yii.t('wui-shared-js', 'FB');
    public fareFamily: string = Yii.t('wui-shared-js', 'FF');
}

@Pipe({
    name: 'computeRule'
})

export class ComputeRulePipe implements PipeTransform {
    public wording: Wording = new Wording();
    public luggageUnit: LuggageUnitPipe = new LuggageUnitPipe();

    public constructor(private readonly priceRealAmount: PriceRealAmountPipe) {
    }

    public transform(rule?: RuleType, fareComponent?: FareComponentInBookingType): IKeyValue[] {
        let transformedRule: IKeyValue;
        const transformedRules: IKeyValue[] = [];
        //TODO : How can we use types like enums : public enumTest: typeof EnumTest = EnumTest;
        const luggage: XRoleForRuleType = "Luggage";
        const exchange: XRoleForRuleType = "Exchange";
        const cancellation: XRoleForRuleType = "Cancellation";
        if (rule) {
            switch (rule.xRole) {
                case luggage:
                    let luggageRule: string = `${rule.luggage?.quantity?.max !== undefined ? rule.luggage?.quantity?.max + "PC" : ''} `;
                    luggageRule += `${rule.luggage?.weight?.max ? rule.luggage?.weight?.max : ''}`;
                    luggageRule += `${this.luggageUnit.transform(rule.luggage?.weight?.xUnit) ? this.luggageUnit.transform(rule.luggage?.weight?.xUnit) : ''}`
                    transformedRule = {
                        key: rule.luggage?.xCategory,
                        value: luggageRule
                    };
                    transformedRules.push(transformedRule);
                    break;
                case exchange:
                    if (rule.penaltyArray && rule.penaltyArray.length) {
                        rule.penaltyArray.forEach((penaltyItem: PenaltyType): void => {
                            transformedRules.push(this.constructCancellationAndExchangeRule(penaltyItem));
                        });
                    }
                    break;
                case cancellation:
                    if (rule.penaltyArray && rule.penaltyArray.length) {
                        rule.penaltyArray.forEach((penaltyItem: PenaltyType): void => {
                            this.constructCancellationAndExchangeRule(penaltyItem);
                        });
                    }
                    break;
                default :
                    return null;
            }
        }
        if (fareComponent) {
            if (fareComponent.fareBasis) {
                transformedRule = {
                    key: this.wording.fareBasis,
                    value: fareComponent.fareBasis?.value
                };
                transformedRules.push(transformedRule);
            }
            if (fareComponent.fareFamily) {
                transformedRule = {
                    key: this.wording.fareFamily,
                    value: fareComponent.fareFamily?.name?.value
                };
                transformedRules.push(transformedRule);
            }
        }
        return transformedRules;
    }

    public constructCancellationAndExchangeRule(penaltyItem: any): IKeyValue {
        let formattedRule: IKeyValue;
        if (penaltyItem.xCountingFrom === EPenaltyType.BeforeDeparture) {
            formattedRule = {
                key: this.wording.cancellationBeforeDeparture,
                value: this.priceRealAmount.transform(penaltyItem?.currency?.value, penaltyItem?.currency?.currencyCode),
            };
        } else {
            if (penaltyItem.xCountingFrom === EPenaltyType.AfterDeparture) {
                formattedRule = {
                    key: this.wording.cancellationAfterDeparture,
                    value: this.priceRealAmount.transform(penaltyItem?.currency?.value, penaltyItem?.currency?.currencyCode),
                };
            }
        }
        return formattedRule;
    }
}
